module.exports = __webpack_public_path__ + "img/Token List Icon.235c23a4.svg";